const objOptionsDropdown = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1
};

const handleIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const img = entry.target;
      const src = img.dataset.src || "";
      if (src) img.src = src;
      observer.unobserve(img);
    }
  });
};

const itemsPerLoad = 40;

// Cache DOM elements
const prodContainer = document.querySelector('.sf-prod__container');
const productSection = document.querySelector('[data-section-type="product-page"]');

function setContainerOverflow(value) {
  if (prodContainer) prodContainer.style.overflow = value;
}

function resetProductSection() {
  if (productSection) {
    productSection.style.position = '';
    productSection.style.zIndex = '';
  }
}

// Build the .current span innerHTML — used both on init and on option select
function buildCurrentHTML(url, text) {
  return `
    ${url ? `<img src="${url}" alt="" width="50px" height="50px" loading="lazy" style="display: inline-block; margin-right: 5px; width: 100%; height: auto">` : ''}
    ${text}
  `;
}

function closeAllDropdowns() {
  document.querySelectorAll(".dropdown-select.open").forEach((dropdown) => {
    dropdown.classList.remove("open");
    dropdown.querySelectorAll(".option").forEach((opt) => opt.removeAttribute("tabindex"));
  });
  setContainerOverflow("");
  resetProductSection();
}

function create_custom_dropdowns() {
  // The dropdown UI built below copies the select's classes, so match selects
  // only: running this again must not treat that UI as an option-less select.
  const dropdownFilterOptions = document.querySelectorAll("select.dropdown-filter-option");

  dropdownFilterOptions.forEach((select) => {
    const sizeOption = select.querySelectorAll("option:not([value=''])").length;
    if (sizeOption === 0) {
      const parentOption = select.closest(".main-product__block-custom-properties");
      if (parentOption) {
        parentOption.style.display = "none";
        // Collapse the outer block too, otherwise its margin still adds a gap
        const blockWrapper = parentOption.closest(".main-product__block");
        if (blockWrapper) blockWrapper.classList.add("is-empty");
      }
      select.removeAttribute("required"); // Hidden block must not block form validation
      return; // No valid options — skip creating the dropdown UI
    }

    // Guard: skip if already initialised
    if (select.nextElementSibling?.classList.contains("dropdown-select")) return;

    const dropdownSelect = document.createElement("div");
    dropdownSelect.classList.add("dropdown-select", "wide", ...select.classList);
    dropdownSelect.setAttribute("tabindex", "0");
    dropdownSelect.innerHTML = `
      <span class="current"></span>
      <div class="list">
        <div class="dd-search">
          <input placeholder="Search here" autocomplete="off" class="dd-searchbox" type="text">
        </div>
        <ul></ul>
      </div>
    `;
    select.insertAdjacentElement("afterend", dropdownSelect);

    const dropdown = select.nextElementSibling;
    const options = select.querySelectorAll("option");
    const selectedOption = select.querySelector("option:checked");

    dropdown.querySelector(".current").innerHTML = buildCurrentHTML(
      selectedOption?.dataset?.url,
      selectedOption?.dataset?.displayText || selectedOption?.textContent
    );

    const listUl = dropdown.querySelector(".list ul");
    const searchBox = dropdown.querySelector(".dd-searchbox");
    let loadedItemsCount = 0;

    const observerDropdownFilter = new IntersectionObserver(handleIntersection, objOptionsDropdown);

    searchBox.addEventListener("keyup", handleSearchFilter);

    function loadItems() {
      const fragment = document.createDocumentFragment();
      const start = loadedItemsCount;
      const end = Math.min(start + itemsPerLoad, options.length);
      const newImages = [];

      for (let i = start; i < end; i++) {
        const option = options[i];
        if (!option.value) continue; // Skip placeholder option (value="")

        const imgLink = option.dataset.url || "";
        const li = document.createElement("li");
        li.className = `option ${option.selected ? "selected" : ""}`;
        li.dataset.value = option.value;
        li.dataset.displayText = option.dataset.displayText || "";
        li.dataset.url = imgLink;

        li.innerHTML = `
          ${imgLink ? `<img src="https://placehold.co/50x50?text=Tartanvibesclothing" data-src="${imgLink}" alt="" loading="lazy" width="50px" height="50px" style="display: inline-block; margin-right: 5px; width: 100%; height: auto">` : ''}
          ${option.textContent}
        `;

        const img = li.querySelector("img[data-src]");
        if (img) newImages.push(img);

        fragment.appendChild(li);
      }

      listUl.appendChild(fragment);
      newImages.forEach((image) => observerDropdownFilter.observe(image));
      loadedItemsCount += end - start;

      if (loadedItemsCount < options.length) {
        listUl.addEventListener("scroll", handleScroll);
      }
    }

    function handleScroll() {
      if (listUl.scrollTop + listUl.clientHeight >= listUl.scrollHeight - 1) {
        listUl.removeEventListener("scroll", handleScroll);
        loadItems();
      }
    }

    loadItems();

    const filterWrapper = select.closest(".dropdown-filter");
    if (filterWrapper) filterWrapper.classList.add("is-ready");

    // Sync form-control--warning (added by validateForm) → error class on visible dropdown
    new MutationObserver(() => {
      const hasWarning = select.classList.contains("form-control--warning");
      dropdownSelect.classList.toggle("error", hasWarning);
    }).observe(select, { attributes: true, attributeFilter: ["class"] });
  });
}

function handleSearchFilter(event) {
  const searchValue = event.target.value.toLowerCase();
  const dropdown = event.target.closest(".dropdown-select");
  if (!dropdown) return;
  dropdown.querySelectorAll("ul > li").forEach((option) => {
    option.style.display = option.textContent.toLowerCase().includes(searchValue) ? "block" : "none";
  });
}

document.addEventListener("click", function (event) {
  const target = event.target;
  const dropdownSelect = target.closest(".dropdown-select");

  // Click outside — close all dropdowns
  if (!dropdownSelect) {
    closeAllDropdowns();
    return;
  }

  // Ignore clicks on the search box
  if (target.classList.contains("dd-searchbox")) return;

  // Handle option selection
  const option = target.closest(".option");
  if (option) {
    const list = option.closest(".list");
    list.querySelector(".selected")?.classList.remove("selected");
    option.classList.add("selected");

    dropdownSelect.querySelector(".current").innerHTML = buildCurrentHTML(
      option.dataset.url,
      option.dataset.displayText || option.textContent
    );

    const select = dropdownSelect.previousElementSibling;
    if (select) {
      select.value = option.dataset.value;
      select.classList.remove("form-control--warning");
      dropdownSelect.classList.remove("form-control--warning");
      select.dispatchEvent(new Event("change"));
    }
  }

  // Toggle dropdown open/close
  dropdownSelect.classList.toggle("open");
  if (dropdownSelect.classList.contains("open")) {
    dropdownSelect.querySelectorAll(".option").forEach((opt) => opt.setAttribute("tabindex", "0"));
    dropdownSelect.querySelector(".selected")?.focus();
    setContainerOverflow("initial");
    if (productSection) {
      productSection.style.position = 'relative';
      productSection.style.zIndex = 2;
    }
  } else {
    dropdownSelect.querySelectorAll(".option").forEach((opt) => opt.removeAttribute("tabindex"));
    dropdownSelect.focus();
    setContainerOverflow("");
    resetProductSection();
  }
});

document.addEventListener("keydown", function (event) {
  const dropdownSelect = event.target.closest(".dropdown-select");
  if (!dropdownSelect) return;

  const focusedOption =
    dropdownSelect.querySelector(".list .option:focus") ||
    dropdownSelect.querySelector(".list .option.selected");

  switch (event.key) {
    case "Enter":
      event.preventDefault();
      if (dropdownSelect.classList.contains("open")) {
        focusedOption?.click();
        setContainerOverflow("");
        resetProductSection();
      } else {
        dropdownSelect.click();
      }
      break;
    case "ArrowDown":
      event.preventDefault();
      if (!dropdownSelect.classList.contains("open")) {
        dropdownSelect.click();
      } else {
        focusedOption?.nextElementSibling?.focus();
      }
      break;
    case "ArrowUp":
      event.preventDefault();
      if (!dropdownSelect.classList.contains("open")) {
        dropdownSelect.click();
      } else {
        focusedOption?.previousElementSibling?.focus();
      }
      break;
    case "Escape":
      if (dropdownSelect.classList.contains("open")) {
        dropdownSelect.click();
        setContainerOverflow("");
        resetProductSection();
      }
      break;
  }
});

create_custom_dropdowns();
